"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanInfoMem = void 0;
exports.getInvestmentDisclaimers = getInvestmentDisclaimers;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _wpautop = _interopRequireDefault(require("wpautop"));
function getInvestmentDisclaimers(listing) {
  var investmentDisclaimers = [];
  var isTenanted = listing.tenancyCode === 'TEN' || false;
  var {
    investment
  } = listing;
  if (!investment) return investmentDisclaimers;
  if (isTenanted) {
    investmentDisclaimers.push("* Total annual expenses are based upon information provided by the vendor.\n      They exclude potential costs that will vary according to the purchaser. Excluded costs include,\n      but are not limited to, management and leasing fees, marketing costs, repairs and maintenance.");
  }
  if (!isTenanted) {
    investmentDisclaimers.push("* The rental income figures are based on an estimate by the selling agent\n      of the likely amount the property would rent for if marketed for lease");
  }
  if (investment.landTax) {
    investmentDisclaimers.push('** The land tax estimate assumes that the purchaser owns no other investment property.');
  }
  if (investment.taxDepreciationMin && investment.taxDepreciationMax) {
    investmentDisclaimers.push("*** Total depreciation allowance is based upon information supplied by <a href=\"http://www.bmtqs.com.au/tax-depreciation-calculator\" target=\"_blank\" rel=\"nofollow\">BMT Tax Depreciation Pty Ltd</a>.\n      The estimates are based on the Diminishing Value Method and uses general assumptions concerning construction type, quality and condition of inclusions.\n      A full ATO compliant depreciation schedule should be prepared on the property to confirm exact depreciation entitlements.");
  }

  // General disclaimer for investment data
  investmentDisclaimers.push("All provided figures are estimates and should not be relied upon by a purchaser.\n    The returns are not guaranteed. <a href=\"https://www.raywhite.com/legal-information/\" target=\"_blank\" rel=\"noopener\"> Further disclaimers apply</a>");
  return investmentDisclaimers;
}

/**
 * Clean up the information memorandum data, if any.
 *
 * This is to strip out non-public information and to restructure some parts
 * for easier consumption.
 *
 * @param {boolean} front May be set to false to expose non-public data
 */
var cleanInfoMem = function (id, im) {
  var _context, _context2, _context3, _context4, _context5;
  var front = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // Hide "approval" IMs for the moment, until supported
  if (!im || !im.enabled || im.security === 'approval') return undefined;
  return {
    id: im.id,
    listing: im.listing,
    isPublic: im.security === 'none',
    users: front ? (0, _map.default)(_context = im.users).call(_context, reg => reg.id) : im.users,
    administrators: front ? [] : (0, _filter.default)(_context2 = im.administrators.split(/\s*,\s*/)).call(_context2, x => x),
    sections: (0, _map.default)(_context3 = (0, _sort.default)(_context4 = (0, _filter.default)(_context5 = im.segmentCategories).call(_context5, sc => sc.enabled &&
    // Gallery and Plans are now ignored, will drop server side support some time
    sc.segment.name !== 'Gallery' && sc.segment.name !== 'Plans' &&
    // Registration specific featured not required, so can discard
    sc.segment.name !== 'Register' && (sc.segment.allowContent && sc.content && sc.content !== sc.segment.defaultContent || sc.segment.allowFiles && sc.categories.length || !sc.segment.allowContent && !sc.segment.allowFiles))).call(_context4, (a, b) => b.segment.weight - a.segment.weight)).call(_context3, sc => {
      var _context6;
      var {
        segment
      } = sc;
      var names = [segment.name, ...segment.alternativeNames];
      return {
        name: sc.name ? names[sc.name] || segment.name : segment.name,
        slug: segment.slug,
        content: sc.content ? (0, _wpautop.default)(sc.content) : sc.content,
        categories: (0, _map.default)(_context6 = sc.categories).call(_context6, cat => {
          var _context7;
          return {
            name: cat.name,
            isPublic: im.security === 'none' || !cat.protected,
            files: (0, _map.default)(_context7 = cat.files).call(_context7, file => {
              var _context8;
              return {
                id: file.id,
                description: file.description,
                type: file.file.type,
                size: file.file.size,
                url: (0, _concat.default)(_context8 = "/api/auth/property/".concat(id, "/im/")).call(_context8, file.id),
                store: front ? undefined : file.file
              };
            })
          };
        })
      };
    })
  };
};
exports.cleanInfoMem = cleanInfoMem;